<template>
  <div class="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    ></BlockUI>
    <ModalDocumento
      :dialog="modalDocumento"
      :user="userSelecionado"
      :showButtons="true"
      @reprovar-doc="reprovarDoc"
      @aprovar="aprovar"
      @reprovar="reprovar"
      @close="modalDocumento = false"
    ></ModalDocumento>
    <modalPadrao
      :showModal="modalDialog"
      :ifTitle="true"
      :Title="titleModal"
      :ifTwoBtn="true"
      :TextFirstBtn="'Não'"
      :TextSecondBtn="'Sim'"
      @btnUm="modalDialog = false"
      @btnDois="actionModalPadrao"
    ></modalPadrao>
    <v-dialog
      v-model="receiptModal"
      max-width="450"
      transition="dialog-transition"
    >
      <v-card width="550px">
        <v-btn icon class="ma-0" @click="receiptModal = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-card-text>
          <img
            v-if="proof_of_address != '' && proof_of_address != null"
            style="width:100%; height:auto;"
            :src="`${url_bucket + proof_of_address}`"
          />
          <div v-else>
            Comprovante não enviado!
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card>
      <v-card-title>
        Usuários não aprovados
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Procurar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-flex class="row mx-3 mb-2">
        <v-btn
          @click="changePage('active')"
          :class="withDocuments ? 'colorApp white--text' : 'white grey--text'"
          class="ma-0 mr-2"
          >Com documento</v-btn
        >
        <v-btn
          @click="changePage('canceled')"
          :class="!withDocuments ? 'colorApp white--text' : 'white grey--text'"
          class="ma-0"
          >Sem documento</v-btn
        >
      </v-flex>
      <v-flex sm6 offset-sm10 offset-lg10>
        <download-excel
          class="ml-auto mr-0"
          :data="withDocuments ? usersWithDocuments : usersWithOutDocuments"
          :fields="json_fields"
          name="UsuáriosNãoAprovados.xls"
        >
          <v-btn small class="mr-4">
            <span class="pr-1">Exportar</span>
            <v-icon small class="black--text">insert_drive_file</v-icon>
          </v-btn>
        </download-excel>
      </v-flex>

      <v-flex class="col" v-if="withDocuments">
        <v-data-table
          no-data-text="Nenhum usuário registrado"
          footer-props.items-per-page-text="Linhas por página"
          :headers="headers"
          :items="usersWithDocuments"
          :search="search"
          item-key="name"
          group-key="category"
          class="table-custom-vue elevation-1 mt-2"
          :rows-per-page-items="[
            10,
            25,
            { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
          ]"
        >
          <template v-slot:items="props">
            <td class>{{ props.item.condominio }}</td>
            <td class>{{ props.item.name }}</td>
            <td class>{{ props.item.phone }}</td>
            <td class>{{ props.item.email }}</td>
            <td class>{{ props.item.complement }}</td>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.action="{ item }">
            <!-- <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!item.proof_of_address"
                  icon
                  style="text-decoration: none"
                  target="_blank"
                  :href="
                    `https://pickndrive.s3.amazonaws.com/${item.proof_of_address}`
                  "
                >
                  <v-icon class="blue--text text--darken-4 ma-0"
                    >description</v-icon
                  >
                </v-btn>
              </template>
              <span>Comprovante de endereço</span>
            </v-tooltip> -->
            <!-- <ActionButton
              message="Reprovar usuário"
              icon="delete"
              color="error"
              @onclick="changeUser('delete'), (userId = item.id)"
            /> -->
            <ActionButton
              message="Verificar dados"
              icon="search"
              @onclick="openModalDocumento(item)"
            />
            <ActionButton
              message="Visualizar comprovante"
              icon="assignment"
              @onclick="checkReceipt(item)"
            />
          </template>
        </v-data-table>
      </v-flex>

      <v-flex class="col" v-if="!withDocuments">
        <v-data-table
          no-data-text="Nenhum usuário registrado"
          footer-props.items-per-page-text="Linhas por página"
          :headers="headers"
          :items="usersWithOutDocuments"
          :search="search"
          item-key="id"
          group-key="category"
          class="table-custom-vue elevation-1 mt-2"
          :rows-per-page-items="[
            10,
            25,
            { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
          ]"
        >
          <template v-slot:items="props">
            <td class>{{ props.item.condominio }}</td>
            <td class>{{ props.item.name }}</td>
            <td class>{{ props.item.phone }}</td>
            <td class>{{ props.item.email }}</td>
            <td class>{{ props.item.complement }}</td>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.action="{ item }">
            <ActionButton
              message="Solicitar novas documentações"
              icon="mdi-file-document-plus-outline"
              color="blue"
              @onclick="reprovarDoc(item)"
            />
            <ActionButton
              message="Reprovar usuário"
              icon="delete"
              color="error"
              @onclick="changeUser('delete'), (userId = item.id)"
            />
            <ActionButton
              message="Aprovar usuário"
              icon="check"
              color="success"
              @onclick="changeUser('approve'), (userId = item.id)"
            />
            <ActionButton
              message="Visualizar comprovante"
              icon="assignment"
              @onclick="checkReceipt(item)"
            />
          </template>
        </v-data-table>
      </v-flex>
    </v-card>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import UserController from '../../controllers/UserController';
import modalPadrao from '../shared/ModalPadrao.vue';
import ActionButton from '../shared/ActionButtonsTemplate';
import ModalDocumento from '../shared/ModalDocumento.vue';
import Constants from '../../models/constants/Constants';

export default {
  components: {
    modalPadrao,
    ActionButton,
    ModalDocumento,
  },

  data() {
    return {
      url_bucket: Constants.URL_BUCKET_PICKNDRIVE,
      proof_of_address: '',
      receiptModal: false,
      userSelecionado: {},
      modalDocumento: false,
      withDocuments: true,
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      usersWithDocuments: [],
      usersWithOutDocuments: [],
      search: '',
      json_fields: {
        Cliente: 'condominio',
        Nome: 'name',
        Telefone: 'phone',
        Email: 'email',
      },
      headers: [
        { text: 'Cliente', value: 'condominio' },
        { text: 'Nome', value: 'name' },
        { text: 'Telefone', value: 'phone' },
        { text: 'Email', value: 'email' },
        { text: 'Complemento', value: 'complement' },
        { text: 'Ações', value: 'action' },
      ],
      userController: new UserController(this.$resource),
      modalDialog: false,
      titleModal: '',
      userId: '',
      action: '',
    };
  },

  async created() {
    await this.getUsers();
  },

  methods: {
    checkReceipt(user) {
      this.receiptModal = true;
      this.proof_of_address = user.proof_of_address;
    },
    openModalDocumento(value) {
      this.userSelecionado = value;
      this.modalDocumento = true;
    },
    changePage(status) {
      if (status == 'active') {
        this.withDocuments = true;
      }
      if (status == 'canceled') {
        this.withDocuments = false;
      }
    },
    getUsers() {
      this.userController
        .getAllNotApprovedUsers()
        .then(res => {
          this.usersWithDocuments = [];
          this.usersWithOutDocuments = [];
          for (let value of res) {
            if (value.selfie_uri != null && value.cnh_uri != null) {
              this.usersWithDocuments.push(value);
            } else {
              this.usersWithOutDocuments.push(value);
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    changeUser(action) {
      if (action == 'approve') this.titleModal = 'Deseja aprovar o usuário?';
      else if (action == 'delete')
        this.titleModal = 'Deseja reprovar o usuário?';
      else this.titleModal = 'Deseja reprovar a documentação?';
      this.action = action;
      this.modalDialog = true;
    },

    actionModalPadrao() {
      if (this.action == 'approve') {
        this.approveUser();
      } else if (this.action == 'delete') {
        this.deleteUser();
      } else {
        this.reprovarDocumentacao();
      }
    },
    aprovar(value) {
      this.titleModal = 'Deseja aprovar o usuário?';
      this.action = 'approve';
      this.userId = value.id;
      this.modalDialog = true;
    },
    reprovar(value) {
      this.titleModal = 'Deseja reprovar o usuário?';
      this.action = 'delete';
      this.userId = value.id;
      this.modalDialog = true;
    },

    reprovarDoc(value) {
      this.titleModal = 'Deseja reprovar a documentação do usuário?';
      this.action = 'reprove-doc';
      this.userId = value.id;
      this.modalDialog = true;
    },

    reprovarDocumentacao() {
      this.userController
        .reprovarDocumentacao(this.userId)
        .then(res => {
          this.modalDialog = false;
          this.modalDocumento = false;
          this.$awn.success(res.message);
          this.getUsers();
        })
        .catch(error => {
          this.modalDialog = false;
          this.$awn.alert(error.message);
        });
    },

    approveUser() {
      this.userController
        .userApproval(this.userId)
        .then(res => {
          this.modalDialog = false;
          this.modalDocumento = false;
          console.log(res);
          res.ok === true
            ? this.$awn.success('Usuário aprovado com sucesso.')
            : this.$awn.alert(res.message);
          this.getUsers();
        })
        .catch(error => {
          this.modalDialog = false;
          this.$awn.alert(error.message);
        });
    },

    deleteUser() {
      this.userController
        .forceDelete(this.userId)
        .then(res => {
          this.modalDialog = false;
          this.modalDocumento = false;
          this.$awn.success(res.message);
          this.getUsers();
        })
        .catch(error => {
          this.modalDialog = false;
          this.$awn.alert(error.message);
        });
    },
  },
};
</script>

<style lang="scss">
.action-list button {
  float: right;
}
.table-custom-vue {
  margin: 20px;
}

.filtro-button {
  background: var(--primary-color-hover) !important;
}
.colorApp {
  background-color: var(--secondary-color) !important;
}
</style>
